<template>
  <v-layout row wrap>
    <v-flex xs12>
      <SummaryTitle
        :isCollapsible="isCollapsible"
        :isCollapsed="isCollapsed"
        icon="mail_outline"
        @clickedToggle="toggleIsCollapsed">
        Contacts
        <template v-if="displayAction" v-slot:action>
          <EditButton @click="clickEditContacts" />
        </template>
      </SummaryTitle>
    </v-flex>

    <v-flex v-if="!contentIsCollapsed" class="contact-box--container" xs12>
      <div v-if="userPerson" class="contact-box">
        <ContactDetails :contact="userPerson" />
      </div>

      <div v-if="appointmentContact" class="contact-box">
        <ContactDetails :contact="appointmentContact" />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

import EditButton from '@/components/common/EditButton.vue';
import ContactDetails from '@/components/ContactDetails.vue';
import SummaryTitle from '@/components/common/SummaryTitle.vue';
import CollapsibleSection from '@/mixins/CollapsibleSection';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    ContactDetails,
    EditButton,
    SummaryTitle,
  },
  mixins: [CollapsibleSection],
  computed: {
    ...mapState('Appointment', {
      appointmentContact: state => state.contactComponentData.contact,
    }),
    ...mapState('Auth', {
      userPerson: state => state.person,
    }),
  },
  methods: {
    clickEditContacts() {
      StepUtilities.goToContactStep(this.$router);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/theme';
@import '../styles/vars/typography';
@import '../styles/mixins/breakpoints';

$_contact-box-padding: 1.25rem;

.contact-box {
  overflow-wrap: break-word;
  padding: $_contact-box-padding 0;
  position: relative;

  &:first-child {
    padding-top: $_contact-box-padding * 0.52;
  }

  &:last-child {
    padding-bottom: $_contact-box-padding * 0.52;
  }
}
</style>
